import {useLayoutDataQuery} from "@irati/payrollpay/hooks"
import React, {createContext, ReactNode, useContext} from "react"
import {SalaryBracketModal} from "../components/SalaryBracketModal"

interface StoreContextType {
  schemeType: "home_and_electronics" | "cycle_to_work"
  schemeName: "Home and Electronics" | "Cycle to Work"
  isHE: boolean
}

const StoreContext = createContext<StoreContextType | undefined>(undefined)

export const StoreProvider = ({children}: {children: ReactNode}) => {
  const isHE = window.location.pathname.includes("home_and_electronics")
  const schemeType = isHE ? "home_and_electronics" : "cycle_to_work"

  const {error: layoutError, refetch: refetchLayout} = useLayoutDataQuery(
    {schemeType},
    {
      fetchPolicy: "cache-and-network"
    }
  )

  const showSalaryBracketModal = layoutError && layoutError.message === "PBPRPNoSalaryBracket"

  const handleSalaryBracketSet = async () => {
    try {
      await refetchLayout()
      window.location.reload()
    } catch (error) {
      /* no-op */
    }
  }

  return (
    <StoreContext.Provider
      value={{
        schemeType,
        schemeName: isHE ? "Home and Electronics" : "Cycle to Work",
        isHE
      }}>
      {children}

      <SalaryBracketModal show={showSalaryBracketModal} onSalaryBracketSet={handleSalaryBracketSet} />
    </StoreContext.Provider>
  )
}

export const useStoreContext = () => {
  const context = useContext(StoreContext)
  if (context === undefined) {
    throw new Error("useStoreContext must be used within a StoreProvider")
  }
  return context
}
